var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2851_32398",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2851_32398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.1923C11.0375 12.1923 10.2135 11.8496 9.52813 11.1642C8.84271 10.4788 8.5 9.65484 8.5 8.69236C8.5 7.72986 8.84271 6.90591 9.52813 6.22051C10.2135 5.53509 11.0375 5.19238 12 5.19238C12.9625 5.19238 13.7864 5.53509 14.4718 6.22051C15.1572 6.90591 15.5 7.72986 15.5 8.69236C15.5 9.65484 15.1572 10.4788 14.4718 11.1642C13.7864 11.8496 12.9625 12.1923 12 12.1923ZM4.5 19.8077V17.5846C4.5 17.0949 4.63302 16.6414 4.89905 16.2241C5.16507 15.8068 5.52051 15.486 5.96537 15.2616C6.95384 14.777 7.95096 14.4135 8.95672 14.1712C9.96249 13.9289 10.9769 13.8078 12 13.8078C13.023 13.8078 14.0375 13.9289 15.0432 14.1712C16.049 14.4135 17.0461 14.777 18.0346 15.2616C18.4794 15.486 18.8349 15.8068 19.1009 16.2241C19.3669 16.6414 19.5 17.0949 19.5 17.5846V19.8077H4.5ZM5.99997 18.3077H18V17.5846C18 17.3821 17.9413 17.1946 17.824 17.0221C17.7067 16.8497 17.5474 16.709 17.3461 16.6C16.4846 16.1757 15.6061 15.8542 14.7107 15.6356C13.8152 15.417 12.9117 15.3077 12 15.3077C11.0883 15.3077 10.1847 15.417 9.28927 15.6356C8.39384 15.8542 7.51536 16.1757 6.65382 16.6C6.45254 16.709 6.29325 16.8497 6.17595 17.0221C6.05863 17.1946 5.99997 17.3821 5.99997 17.5846V18.3077ZM12 10.6924C12.55 10.6924 13.0208 10.4965 13.4125 10.1049C13.8041 9.71319 14 9.24236 14 8.69236C14 8.14236 13.8041 7.67153 13.4125 7.27986C13.0208 6.88819 12.55 6.69236 12 6.69236C11.45 6.69236 10.9791 6.88819 10.5875 7.27986C10.1958 7.67153 9.99997 8.14236 9.99997 8.69236C9.99997 9.24236 10.1958 9.71319 10.5875 10.1049C10.9791 10.4965 11.45 10.6924 12 10.6924Z",
    fill: "#78909C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.dd7fc26aa4fcac8967e4747e8a9f668a.svg";
export { ForwardRef as ReactComponent };